import { IconProps } from "./Icon.model";

export function NotificationSquareIcon({
  size = 16,
  fill = "currentColor",
}: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.125 7.875C22.125 4.56129 24.8113 1.875 28.125 1.875C31.4387 1.875 34.125 4.56129 34.125 7.875C34.125 11.1887 31.4387 13.875 28.125 13.875C24.8113 13.875 22.125 11.1887 22.125 7.875Z"
        fill={fillColor}
      />
      <path
        d="M18.9941 3.375C19.9187 3.375 20.3808 3.37525 20.5605 3.62109C20.7403 3.86697 20.5807 4.36802 20.2617 5.37012C20.0103 6.16006 19.875 7.00175 19.875 7.875C19.875 12.4313 23.5687 16.125 28.125 16.125C29.009 16.125 29.8608 15.9859 30.6592 15.7285C31.6373 15.4131 32.1265 15.2555 32.373 15.4346C32.6196 15.6137 32.6205 16.064 32.623 16.9639C32.6246 17.5084 32.625 18.075 32.625 18.6641V18.8359C32.625 22.1218 32.6254 24.7027 32.3545 26.7178C32.0769 28.7828 31.4963 30.4217 30.209 31.709C28.9217 32.9963 27.2828 33.5769 25.2178 33.8545C23.2027 34.1254 20.6218 34.125 17.3359 34.125H17.1641C13.8782 34.125 11.2973 34.1254 9.28223 33.8545C7.21724 33.5769 5.57831 32.9963 4.29102 31.709C3.00372 30.4217 2.42314 28.7828 2.14551 26.7178C1.87462 24.7027 1.87498 22.1218 1.875 18.8359V18.6641C1.87498 15.3782 1.87462 12.7973 2.14551 10.7822C2.42314 8.71724 3.00372 7.07831 4.29102 5.79102C5.57831 4.50372 7.21724 3.92314 9.28223 3.64551C11.2973 3.37462 13.8782 3.37498 17.1641 3.375H18.9941ZM10.5 22.875C9.87868 22.875 9.375 23.3787 9.375 24C9.375 24.6213 9.87868 25.125 10.5 25.125H22.5C23.1213 25.125 23.625 24.6213 23.625 24C23.625 23.3787 23.1213 22.875 22.5 22.875H10.5ZM10.5 15.375C9.87868 15.375 9.375 15.8787 9.375 16.5C9.375 17.1213 9.87868 17.625 10.5 17.625H16.5C17.1213 17.625 17.625 17.1213 17.625 16.5C17.625 15.8787 17.1213 15.375 16.5 15.375H10.5Z"
        fill={fillColor}
      />
    </svg>
  );
}
